import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "keyConnectFilled"
const KeyConnectFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.25 16.875H16.5C16.5 16.047 15.828 15.375 15 15.375V16.875H13.056C12.797 18.068 11.827 19.013 10.578 19.203L4.912 20.068C3.917 20.22 2.884 19.684 2.555 18.65 2.25 17.692 1.875 16.203 1.875 14.638 1.875 13.07 2.25 11.57 2.555 10.607 2.884 9.57 3.92 9.03 4.917 9.182L10.577 10.047C11.828 10.237 12.798 11.182 13.058 12.375H19.281C19.618 12.375 19.935 12.525 20.15 12.783L21.475 14.386 21.674 14.625 21.475 14.864 20.15 16.467C19.935 16.725 19.617 16.875 19.282 16.875H18.75C18.75 16.047 18.078 15.375 17.25 15.375zM6.28 11.965C5.97 11.925 5.689 12.144 5.651 12.454 5.474 13.9 5.475 15.364 5.654 16.81 5.693 17.119 5.974 17.338 6.281 17.3 6.59 17.262 6.81 16.98 6.771 16.672 6.603 15.317 6.603 13.946 6.769 12.592 6.807 12.281 6.587 12.001 6.279 11.963"
            clipRule="evenodd"
          />
          <path d="M12.068 5.25C13.238 5.265 14.378 5.62 15.348 6.273 15.693 6.502 15.784 6.969 15.553 7.312S14.855 7.748 14.512 7.517C13.784 7.026 12.928 6.76 12.052 6.75 11.173 6.74 10.311 6.987 9.572 7.46 9.225 7.683 8.761 7.581 8.538 7.233 8.315 6.883 8.416 6.42 8.765 6.197 9.75 5.567 10.898 5.237 12.068 5.251" />
          <path d="M12 2.25C12.985 2.25 13.96 2.444 14.87 2.82 15.78 3.198 16.607 3.75 17.304 4.448 17.596 4.739 17.596 5.214 17.304 5.507 17.01 5.8 16.536 5.8 16.243 5.507 15.686 4.95 15.024 4.51 14.296 4.207 13.568 3.906 12.788 3.75 12 3.75S10.432 3.906 9.704 4.207 8.314 4.95 7.757 5.507C7.464 5.8 6.99 5.8 6.697 5.507S6.404 4.74 6.697 4.447C7.393 3.75 8.22 3.197 9.13 2.82 10.04 2.444 11.015 2.25 12 2.25" />
        </svg>
      }
    </span>
  )
}
export default KeyConnectFilledIcon
